var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m16.2 11.2 4.9-4.9h-14V16H21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 3.2H7.1V1.8H3.3v28.5h3.9V19.2h21.6l-7.9-7.9zM21 16H7.1V6.3h14l-4.9 4.9z"
  })));
};
export default SvgFlag;